import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19f94a94")

_pushScopeId("data-v-19f94a94")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "kv forseo" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "EECOMM SMARTAX System", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Professional, Trustable, Reliable", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, " Our product is named as SMARTAX system, which also has a POS to mobile applications (Apps) communication function for VAT collection monitoring and real-time information reporting. ", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Contact us →")
const _hoisted_8 = { class: "sec1" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Collect Tax "),
  /*#__PURE__*/_createVNode("br", { class: "hidden-min" }),
  /*#__PURE__*/_createTextVNode("Efficiently")
], -1)
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "slave-title" }, [
  /*#__PURE__*/_createTextVNode(" SMARTAX system is not only prevents"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("merchants’ VAT fraud ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "desc" }, " EECOMM standardize systems designed for digitization and informatization of the tax collection process with secure value-added tax collection solutions to improve the speed and efficiency during the tax collection and administration. ", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Find out more →")
const _hoisted_15 = { class: "sec2" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "container-scene" }
const _hoisted_18 = {
  id: "container-scene",
  class: "title-block"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("EECOMM "),
    /*#__PURE__*/_createVNode("br", { class: "hidden-min" }),
    /*#__PURE__*/_createTextVNode("SMARTAX System")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "sub" }, "Core Value")
], -1)
const _hoisted_20 = { class: "scroll-nav" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "01", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Guaranteed Fraud-free")
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "02", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Low Investment")
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "03", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Fully Controllable")
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "04", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" High Precision")
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "05", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Rapid Deployment")
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "06", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" User Friendliness")
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-19f94a94><div class=\"scroll-nav-content\" data-v-19f94a94><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin1\" class=\"nav-item-wrapper\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>01</div><div class=\"item-icon icon-01\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>Guaranteed Fraud-free</div><div class=\"item-content\" data-v-19f94a94> The SMARTAX VAT printer is equipped with tamper-proof alarms to prevent merchants from tampering or deliberately disabling the connection. Every receipt has Sid9Code and only can scan and verify with particular App. </div></div></div><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin2\" class=\"nav-item-wrapper\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>02</div><div class=\"item-icon icon-02\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>Low Investment</div><div class=\"item-content\" data-v-19f94a94> SMARTAX system equipped with all the functions of collecting VAT. We satisfy all the needs from the government to merchants, merchants to customers. No need to purchase printers, receipts, receipt scanners one by one. </div></div></div><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin3\" class=\"nav-item-wrapper\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>03</div><div class=\"item-icon icon-03\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>Fully Controllable</div><div class=\"item-content\" data-v-19f94a94> SMARTAX system records every sale transaction data. Make it more organized for the tax bureau. The tax bureau can monitor the VAT sales receipts of all the merchants in real-time. </div></div></div><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin4\" class=\"nav-item-wrapper\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>04</div><div class=\"item-icon icon-04\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>High Precision</div><div class=\"item-content\" data-v-19f94a94> Only the receipt with Sid9code is a verified VAT receipt. We record all the transaction data including tax everytime there’s a payment. All the data will automatically show in TAX BI system and can be monitored in real-time by the tax bureau. </div></div></div><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin5\" class=\"nav-item-wrapper\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>05</div><div class=\"item-icon icon-05\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>Rapid Deployment</div><div class=\"item-content\" data-v-19f94a94> We have a professional team of installing the printers in merchants, tutoring how to finish a payment and print out the receipt. </div></div></div><div class=\"scroll-nav-item\" data-v-19f94a94><div id=\"scene-pin6\" class=\"nav-item-wrapper nav-item-wrapper-last\" data-v-19f94a94><div class=\"item-num\" data-v-19f94a94>06</div><div class=\"item-icon icon-06\" data-v-19f94a94></div><div class=\"item-title\" data-v-19f94a94>User Friendliness</div><div class=\"item-content\" data-v-19f94a94> The SMARTAX system has a human-computer interaction design concept, and the user interface is friendly, simple, clean and intuitive. </div></div></div></div></div>", 1)
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "sec3" }, [
  /*#__PURE__*/_createVNode("div", { class: "desc-block forseo" }, [
    /*#__PURE__*/_createVNode("p", null, "Reliable Solution For Tax Fraud Problem"),
    /*#__PURE__*/_createVNode("p", null, " We Added Tax (VAT) & Goods and Sales Tax (GST) are vulnerable to evasion and fraud, there are many ways in which these taxes can be evaded or fraudulently exploited but with EECOMM most advanced value-added tax collection methods, including real-time monitoring and a legal sales certification system the tax fraud problems can be solved once and for all. ")
  ])
], -1)
const _hoisted_35 = { class: "sec4 forseo" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "cards card1" }, [
  /*#__PURE__*/_createVNode("p", null, "SMARTAX BI"),
  /*#__PURE__*/_createVNode("p", null, " An AI and ML Central Monitoring System (CMS) with real-time monitoring of VAT activities. The system will provide complete data and statistics to the tax bureau through many functions. ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "cards card2" }, [
  /*#__PURE__*/_createVNode("p", null, "AIVAT® System"),
  /*#__PURE__*/_createVNode("p", null, " A data analytical system that gathered tax related data for analysis to forecast the trend of the national economy growth. ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "cards card3" }, [
  /*#__PURE__*/_createVNode("p", null, "Data-Driven Decision"),
  /*#__PURE__*/_createVNode("p", null, " Based on smart data-driven decisions, the tax bureau is able to use powerful analysis and actionable insights to support the future development of the government projects. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GridLine),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "contact-us"
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createVNode(_component_router_link, {
            to: "/solution",
            class: "find-out-more"
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("ul", _hoisted_20, [
              _createVNode("li", {
                class: {'active': _ctx.scene1}
              }, [
                _hoisted_21,
                _hoisted_22
              ], 2),
              _createVNode("li", {
                class: {'active': _ctx.scene2}
              }, [
                _hoisted_23,
                _hoisted_24
              ], 2),
              _createVNode("li", {
                class: {'active': _ctx.scene3}
              }, [
                _hoisted_25,
                _hoisted_26
              ], 2),
              _createVNode("li", {
                class: {'active': _ctx.scene4}
              }, [
                _hoisted_27,
                _hoisted_28
              ], 2),
              _createVNode("li", {
                class: {'active': _ctx.scene5}
              }, [
                _hoisted_29,
                _hoisted_30
              ], 2),
              _createVNode("li", {
                class: {'active': _ctx.scene6}
              }, [
                _hoisted_31,
                _hoisted_32
              ], 2)
            ])
          ])
        ]),
        _hoisted_33
      ])
    ]),
    _hoisted_34,
    _createVNode("div", _hoisted_35, [
      _createVNode(_component_GridLine),
      _hoisted_36,
      _hoisted_37,
      _hoisted_38
    ])
  ]))
})